/* top-navigation.tsx generated by @compiled/babel-plugin v0.29.1 */
import "./top-navigation.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { forwardRef, Fragment } from 'react';
import Button, { IconButton } from '@atlaskit/button/new';
import ChatIcon from '@atlaskit/icon/core/ai-chat';
import SearchIcon from '@atlaskit/icon/core/search';
import MenuIcon from '@atlaskit/icon/core/sidebar-expand';
import ChevronDownIcon from '@atlaskit/icon/utility/chevron-down';
import { Anchor, Inline, Pressable, Text } from '@atlaskit/primitives';
import { Hide, Show } from '@atlaskit/primitives/responsive';
import { List } from '../../components/list';
import { ListItem } from '../../components/list-item';
import AppSwitcherIcon from './app-switcher-icon';
var styles = {
  imageContainer: "_1e0c1txw _4cvr1h6o _4t3izwfg _2rkoiti9",
  commonActionsContainer: "_1e0c1txw _zulpu2gc _1bah1h6o _1bsb1osq _yyhycs5v",
  searchButtonRoot: "_yv0e1mfv _4cvr1h6o _11q71j9a _2rkoiti9 _vchhusvi _80om1kdv _1e0cglyw _4t3izwfg _p12f1kvu _1rjcze3t _18zr12x7 _1bsb1osq _19lc1d5g _j6xtr01l _181n11p5",
  searchButtonText: "_yyhyjvu9 _1ii7kb7n",
  searchIconBefore: "_1e0c1txw _yyhykb7n _1ii7kb7n",
  searchElemAfter: "_1e0c1txw _yyhy11wp _1ii7kb7n",
  mobileUserActions: "_bfhk18uv",
  userActions: "_yyhy11wp",
  userActionsList: "_4cvr1h6o _1e0c1txw _zulp1b66",
  homeActions: "_4cvr1h6o _1e0c1txw _zulp1b66 _yyhykb7n",
  hiddenForSmallViewports: "_1e0cglyw _181n18uv"
};

/**
 * __Nav logo__
 *
 * The product logo for the top navigation.
 */
export var NavLogo = function NavLogo(_ref) {
  var href = _ref.href,
    logo = _ref.logo,
    mobileLogo = _ref.mobileLogo,
    onClick = _ref.onClick,
    label = _ref.label;
  return /*#__PURE__*/React.createElement(Anchor, {
    "aria-label": label,
    href: href,
    xcss: styles.imageContainer,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Show, {
    below: "sm"
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center"
  }, mobileLogo)), /*#__PURE__*/React.createElement(Hide, {
    below: "sm"
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center"
  }, logo)));
};
/**
 * __App switcher__
 *
 * The app switcher button for the top navigation. Allows users to switch between Atlassian products.
 */
export var AppSwitcher = function AppSwitcher(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? 'App switcher' : _ref2$label,
    onClick = _ref2.onClick,
    interactionName = _ref2.interactionName;
  return /*#__PURE__*/React.createElement(Hide, {
    below: "sm"
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: AppSwitcherIcon,
    label: label,
    appearance: "subtle",
    onClick: onClick,
    interactionName: interactionName
  }));
};
/**
 * __Mobile hamburger__
 *
 * TODO: check if this is still needed and remove
 */
export var MobileHamburger = function MobileHamburger(_ref3) {
  var label = _ref3.label,
    onClick = _ref3.onClick,
    interactionName = _ref3.interactionName;
  return /*#__PURE__*/React.createElement(Show, {
    below: "sm"
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: MenuIcon,
    label: label,
    appearance: "subtle",
    onClick: onClick,
    interactionName: interactionName
  }));
};

/**
 * __Home actions__
 *
 * Wrapper for the top navigation actions on the inline-start (left) side of the top navigation.
 */
export var HomeActions = function HomeActions(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax([styles.homeActions])
  }, children);
};

/**
 * __Search__
 *
 * The search element for the top navigation.
 */
export var Search = function Search(_ref5) {
  var label = _ref5.label,
    onClick = _ref5.onClick,
    _ref5$iconBefore = _ref5.iconBefore,
    IconBefore = _ref5$iconBefore === void 0 ? SearchIcon : _ref5$iconBefore,
    elemAfter = _ref5.elemAfter,
    interactionName = _ref5.interactionName;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Pressable, {
    style: {
      // To win the specificity war against Emotion we move this into inline styles
      // When Emotion has been stripped from the Design System move this to Compiled.
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      cursor: 'text',
      border: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border-input, #8590A2)")
    },
    onClick: onClick,
    xcss: styles.searchButtonRoot,
    interactionName: interactionName
  }, /*#__PURE__*/React.createElement("span", {
    className: ax([styles.searchIconBefore])
  }, /*#__PURE__*/React.createElement(IconBefore, {
    color: "var(--ds-icon-subtle, #626F86)",
    spacing: "spacious",
    label: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: ax([styles.searchButtonText])
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest"
  }, label)), elemAfter && /*#__PURE__*/React.createElement("span", {
    className: ax([styles.searchElemAfter])
  }, elemAfter)), /*#__PURE__*/React.createElement(Show, {
    below: "xs"
  }, /*#__PURE__*/React.createElement(IconButton, {
    label: label,
    appearance: "subtle",
    icon: SearchIcon,
    onClick: onClick,
    interactionName: interactionName
  })));
};
/**
 * __Common actions__
 *
 * Wrapper for the actions in the middle of the top navigation.
 */
export var CommonActions = function CommonActions(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax([styles.commonActionsContainer])
  }, children);
};
/**
 * __Chat button__
 *
 * The chat button for the top navigation.
 * TODO: check if this is still needed and remove. Jira doesn't use it - there's a separate button for ConversationAssistant
 */
export var ChatButton = function ChatButton(_ref7) {
  var children = _ref7.children,
    onClick = _ref7.onClick,
    isSelected = _ref7.isSelected,
    interactionName = _ref7.interactionName;
  return /*#__PURE__*/React.createElement(ListItem, {
    xcss: styles.hiddenForSmallViewports
  }, /*#__PURE__*/React.createElement(Button, {
    appearance: "default",
    iconBefore: ChatIcon,
    onClick: onClick,
    isSelected: isSelected,
    interactionName: interactionName
  }, children));
};

/**
 * __User actions__
 *
 * Wrapper for the top navigation actions on the inline-end (right) side of the top navigation.
 */
export var UserActions = function UserActions(_ref8) {
  var children = _ref8.children,
    _ref8$label = _ref8.label,
    label = _ref8$label === void 0 ? 'Actions' : _ref8$label;
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": label,
    className: ax([styles.userActions])
  }, /*#__PURE__*/React.createElement(List, {
    xcss: styles.userActionsList
  }, children));
};
/**
 * __User action__
 *
 * A user action button for the top navigation. Used for adding custom actions that are not already provided.
 *
 * For common actions, like `Notifications`, `Help`, `Profile`, `Settings`, use the provided components as appropriate.
 */
export var UserAction = /*#__PURE__*/forwardRef(function (_ref9, forwardedRef) {
  var children = _ref9.children,
    icon = _ref9.icon,
    onClick = _ref9.onClick,
    isSelected = _ref9.isSelected,
    testId = _ref9.testId,
    interactionName = _ref9.interactionName;
  return /*#__PURE__*/React.createElement(ListItem, {
    xcss: styles.hiddenForSmallViewports
  }, /*#__PURE__*/React.createElement(IconButton, {
    ref: forwardedRef,
    icon: icon,
    label: children,
    onClick: onClick,
    appearance: "subtle",
    isSelected: isSelected,
    isTooltipDisabled: false,
    testId: testId,
    interactionName: interactionName
  }));
});
/**
 * __Avatar dropdown action__
 *
 * A user action that displays a dropdown on small viewports.
 */
export var AvatarDropdownAction = function AvatarDropdownAction(_ref10) {
  var children = _ref10.children,
    onClick = _ref10.onClick,
    Icon = _ref10.icon,
    interactionName = _ref10.interactionName;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(UserAction, {
    icon: Icon,
    onClick: onClick,
    interactionName: interactionName
  }, children), /*#__PURE__*/React.createElement(Show, {
    below: "sm"
  }, /*#__PURE__*/React.createElement(Pressable, {
    onClick: onClick,
    "aria-label": children,
    xcss: styles.mobileUserActions,
    interactionName: interactionName
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    space: "space.100"
  }, /*#__PURE__*/React.createElement(Icon, {
    label: ""
  }), /*#__PURE__*/React.createElement(ChevronDownIcon, {
    label: "",
    color: "var(--ds-icon, #44546F)"
  })))));
};

/**
 * We are flattening the top navigation root into the page layout top bar component
 * to support the visual refresh. This isn't needed anymore and will be cleaned up soon.
 *
 * @private
 * @deprecated
 */
export var TopNavigation = function TopNavigation(_ref11) {
  var children = _ref11.children;
  return /*#__PURE__*/React.createElement(Fragment, null, children);
};